// @ts-nocheck
/**
 * OOTW Cart Plan Change.
 *
 * Handles two interactions inside the cart drawer:
 *
 *  1. PLAN CHANGE DROPDOWN (.ootw-cart-plan-change) — shown on existing
 *     subscription items. When the user picks a different delivery frequency,
 *     calls /cart/change.js to swap the selling plan, then re-renders the
 *     section via the Section Rendering API so the drawer morphs with fresh state.
 *
 *  2. UPGRADE BUTTON (.ootw-cart-upgrade + [data-ootw-upgrade-btn]) — shown on
 *     one-time items that have selling plans available. Clicking UPGRADE converts
 *     the line item from a one-time purchase to a subscription at the selected
 *     plan (or the only available plan).
 *
 * All DOM queries use event delegation so the listeners survive morph updates.
 * No Skio API key is used — plan ids come from the Liquid-rendered HTML.
 */
(function () {
  var SECTION_ID = 'ootw-cart-drawer';

  /** Show the cart-drawer skeleton while the plan change is processing. */
  function startLoading() {
    var d = document.querySelector('cart-drawer-component');
    if (d) d.setAttribute('data-ootw-loading', '');
  }

  /** Called on success/error to clear the skeleton. */
  function stopLoading() {
    var d = document.querySelector('cart-drawer-component');
    if (d) d.removeAttribute('data-ootw-loading');
  }

  /**
   * POST /cart/change.js with sections, then fire cart:update with the
   * returned section HTML so Horizon's cart-items-component can morph.
   *
   * @param {string}  itemKey  - The line item key
   * @param {number}  planId   - The target selling plan id (integer)
   * @param {number}  quantity - Current line item quantity
   */
  function changePlan(itemKey, planId, quantity) {
    startLoading();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
        selling_plan: planId,
        sections: SECTION_ID,
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/change.js ' + r.status);
        return r.json();
      })
      .then(function (cartData) {
        // cartData.sections['ootw-cart-drawer'] = fresh section HTML string
        var sectionHtml = cartData.sections && cartData.sections[SECTION_ID];

        // Fire cart:update. Horizon's cart-items-component reads
        // event.detail.data.sections[sectionId] and morphs in place.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartData,
              data: {
                sections: sectionHtml ? { [SECTION_ID]: sectionHtml } : {},
              },
            },
          })
        );

        // If no section HTML came back (shouldn't happen), at least hide skeleton.
        if (!sectionHtml) stopLoading();
      })
      .catch(function (err) {
        console.error('[ootw-cart-plan-change]', err);
        stopLoading();
        document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true }));
      });
  }

  // ── 1. Plan-change select (existing subscription items) ───────────────────

  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!(select instanceof Element)) return;
    if (!select.matches('[data-ootw-plan-change]')) return;
    // Only act on <select> elements (not the hidden <input> in the upgrade block)
    if (select.tagName !== 'SELECT') return;

    // The plan-change wrapper holds item key + quantity as data attributes.
    // It lives on .ootw-cart-plan-change for existing subscription rows.
    var wrapper = select.closest('.ootw-cart-plan-change');
    if (!wrapper) return; // belongs to the upgrade block — handled separately

    var itemKey = wrapper.dataset.itemKey;
    var quantity = parseInt(wrapper.dataset.itemQuantity || '1', 10) || 1;
    var planId = parseInt(select.value, 10);
    if (!itemKey || !planId) return;

    changePlan(itemKey, planId, quantity);
  });

  // ── 2. Upgrade button (one-time → subscription) ───────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target;
    if (!(btn instanceof Element)) return;
    btn = btn.closest('[data-ootw-upgrade-btn]');
    if (!btn) return;

    var wrapper = btn.closest('.ootw-cart-upgrade');
    if (!wrapper) return;

    var itemKey = wrapper.dataset.itemKey;
    var quantity = parseInt(wrapper.dataset.itemQuantity || '1', 10) || 1;

    // Plan id: from a <select data-ootw-plan-change> or a hidden <input>.
    var planEl = wrapper.querySelector('[data-ootw-plan-change]');
    var planId = planEl ? parseInt(planEl.value, 10) : 0;
    if (!itemKey || !planId) return;

    btn.disabled = true;
    changePlan(itemKey, planId, quantity);
  });
})();
